<script context="module">
  /**
   * @typedef {Object} Tag
   * @property {string} name
   * @property {string} [href]
   */
</script>

<script>
  import { getTheme } from "../utilities/themes";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The tag in the card
   * @type {Tag[]}
   */
  export let tags = null;

  let componentClass = "";
  export { componentClass as class };

  export let bulletClass = "";

  const defaultBulletClasses =
    "after:absolute after:w-1 after:h-1 after:-right-3 after:top-[50%] after:translate-y-[-50%]";

  /**
   * The theme of the tags
   * @type {import($lib/utilities/theme.js').ThemeName} ThemeName
   */
  export let theme = "white";

  const linkThemeName = getTheme(theme).componentColorTheme ?? "white";
  const linkTheme = getTheme(linkThemeName);
</script>

{#if tags.length > 0}
  <ul {id} class="flex list-none flex-wrap {componentClass}">
    {#each tags as tag, idx}
      <li
        class="relative {idx !== tags.length - 1
          ? `after:bg-current ${defaultBulletClasses} ${bulletClass}`
          : ''}"
      >
        {#if tag.href}
          <a
            label={tag.name}
            href={tag.href}
            class="hover:underline {linkTheme.textColor}"
            data-sveltekit-reload
          >
            {tag.name}
          </a>
        {:else if tag.name}
          {tag.name}
        {/if}
      </li>
    {/each}
  </ul>
{/if}
